export default __webpack_public_path__ + "static/media/gpi-rebate.05309fe6.webp";